declare const AgamaStats: any
declare const Agama: any

const resolveAgamaLogLevel = (verbose?: string | number) => {
    if (typeof Agama === 'undefined' || !Agama.LogLevel) {
        return undefined
    }
    if (typeof verbose === 'number') {
        return verbose
    }
    const levelName = verbose ? String(verbose).split('.').pop() : undefined
    return levelName ? Agama.LogLevel[levelName] : undefined
}

const applyAgamaLogLevel = (verbose?: string | number) => {
    if (typeof Agama === 'undefined' || typeof Agama.setLogLevel !== 'function') {
        return undefined
    }

    const level = resolveAgamaLogLevel(verbose)
    if (level != null) {
        Agama.setLogLevel(level)
    }
    return level
}

export class AgamaAnalytics {
    private static instance: any
    public static isSessionOpen: boolean = false
    public static getInstance(agamaAnalyticsConfig: any, version: any, name: any, deviceData: any, deviceType: any,platformtype:any, isWeb : boolean, isPlatform:any) {
        if (!AgamaAnalytics.instance) {
            if (!name || !deviceData) {
                console.warn('[AGAMA_BANDWIDTH] Agama not initialized yet (missing app name or device data)')
                return undefined;
            }
            if (typeof AgamaStats === 'undefined') {
                console.error('[AGAMA_BANDWIDTH] AgamaStats script not loaded — check /assets/empstats.es6.min.js in Network tab')
                return undefined;
            }
            const agamaLogLevel = applyAgamaLogLevel(agamaAnalyticsConfig.verbose)
            var args = {
                appName: name ? name : "",
                appVersion: version ? version : "",
                configString: agamaAnalyticsConfig._configuration,
                // EmpStats calls Agama.setLogLevel(verbose). A string makes the
                // numeric level check fail and every INFO/DEBUG line prints.
                verbose: agamaLogLevel ?? Agama.LogLevel.ERROR,
                userAccountId: localStorage.getItem('CURRENT_PROFILE_ID'),
                env: deviceType,
                player: agamaAnalyticsConfig.playerName,
                playerVersion: agamaAnalyticsConfig.playerVersion,
                deviceId: deviceData?.uniqueDeviceId,
                envArgs: {
                    // only pc or tv
                    deviceType: platformtype,
                    userAccountId: localStorage.getItem('CURRENT_PROFILE_ID'),
                    player: agamaAnalyticsConfig.playerName,
                    playerVersion: agamaAnalyticsConfig.playerVersion
                },
            };
            applyAgamaLogLevel(agamaAnalyticsConfig.verbose)
            AgamaAnalytics.instance = new AgamaStats.EmpStats(args);
            applyAgamaLogLevel(agamaLogLevel ?? Agama.LogLevel.ERROR)
            AgamaAnalytics.instance.setUserAccountId(localStorage.getItem('CURRENT_PROFILE_ID'))
            setDeviceMetadata(AgamaAnalytics.instance, deviceData, deviceType,agamaAnalyticsConfig ,isWeb, isPlatform )
            if (agamaAnalyticsConfig.verbose === 'Agama.LogLevel.DEBUG') {
                console.log('[AGAMA_DEBUG] Agama analytics initialized', {
                    verbose: agamaAnalyticsConfig.verbose,
                    player: agamaAnalyticsConfig.playerName,
                    playerVersion: agamaAnalyticsConfig.playerVersion,
                    agamaStatsLoaded: typeof AgamaStats !== 'undefined',
                    agamaLoaded: typeof Agama !== 'undefined',
                    shakaLoaded: typeof (window as any).shaka !== 'undefined',
                })
            }
        }
        return AgamaAnalytics.instance
    }
    public static getSessionOpen() {
        return AgamaAnalytics.isSessionOpen
    }
    public static setSessionOpen(value: boolean) {
        AgamaAnalytics.isSessionOpen = value
    }
}
const setDeviceMetadata = (instance: any, deviceData: any, deviceType: any, agamaconfig:any, isWeb:boolean, isPlatform:any) => {   
    const tizentvwasm = window?.tizentvwasm
    let osVersion = "unknown"
    let model = "unknown"
    if(tizentvwasm && typeof tizentvwasm !== undefined){
        let res = tizentvwasm.availableApis?.[1]?.version
        osVersion = res.charAt(0)
    } 
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.APPLICATION, 'Ooredoo TV')
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_BROWSER, deviceData?.deviceName)
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_BROWSER_VERSION,deviceData?.osVersion ?? localStorage.getItem("deviceOSVersion") ?? osVersion) 
    !isWeb && instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_MANUFACTURER, isPlatform('webos') ? 'LG': isPlatform('tizen')? 'Samsung' :
        deviceData?.deviceName === "Mac"? "Apple": "unknown")
    !isWeb && instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_MODEL, localStorage.getItem("deviceModel") ?? model )
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_OS, deviceData?.deviceOS)
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_OS_VERSION, deviceData?.osVersion ?? localStorage.getItem("deviceOSVersion") ?? osVersion)
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_TYPE, isPlatform('webos') ? 'WebOs': isPlatform('tizen')? 'Tizen' :
        deviceData?.deviceName === "Mac"? "Mac": "unknown")
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.USER_ACCOUNT_ID, localStorage.getItem('CURRENT_PROFILE_ID'))
    instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_IP, localStorage.getItem('PUBLIC_IP'))
    navigator.geolocation.getCurrentPosition((position) => {
        let lat = position.coords.latitude;
        let long = position.coords.longitude;
        instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_LATITUDE, lat)
        instance.getEmpClient().setDeviceMetadata(DeviceMetadata.DEVICE_LONGITUDE, long)
    });
    instance.sessionMetadata(SessionMetadata.CONTENT_CA_SYSTEM, agamaconfig?.caSystem);
    instance.sessionMetadata(SessionMetadata.CDN, agamaconfig?.cdn);
    instance.getEmpClient().setMeasurement('SEGMENT_PROFILE_NR',localStorage.getItem('CURRENT_PROFILE_ID'))

}

export enum DeviceMetadata {
    PLAYER = 'PLAYER',
    PLAYER_VERSION = 'PLAYER_VERSION',
    DEVICE_BROWSER = 'DEVICE_BROWSER',
    DEVICE_BROWSER_VERSION = 'DEVICE_BROWSER_VERSION',
    DEVICE_OS = 'DEVICE_OS',
    DEVICE_OS_VERSION = 'DEVICE_OS_VERSION',
    DEVICE_ID = 'DEVICE_ID',
    DEVICE_TYPE = 'DEVICE_TYPE',
    DEVICE_MANUFACTURER = 'DEVICE_MANUFACTURER',
    DEVICE_MODEL = 'DEVICE_MODEL',
    DEVICE_IP = 'DEVICE_IP',
    DEVICE_LATITUDE = 'DEVICE_LATITUDE',
    DEVICE_LONGITUDE = 'DEVICE_LONGITUDE',
    EMPCLIENT_INTEGRATION_VERSION = 'EMPCLIENT_INTEGRATION_VERSION',
    EMPCLIENT_INTEGRATION_BUILDDATE = 'EMPCLIENT_INTEGRATION_BUILDDATE',
    DATA_CONNECTION_TYPE = 'DATA_CONNECTION_TYPE',
    APPLICATION = 'APPLICATION',
    APPLICATION_VERSION = 'APPLICATION_VERSION',
    USER_ACCOUNT_ID = 'USER_ACCOUNT_ID',
}
export enum SessionMetadata {
    CONTENT_CA_SYSTEM = 'CONTENT_CA_SYSTEM',
    CDN = 'CDN',
    CONTENT_TYPE = 'CONTENT_TYPE',
    CONTENT_SERVICE_TITLE = 'CONTENT_SERVICE_TITLE',
    CONTENT_TITLE = 'CONTENT_TITLE',
    MANIFEST_URI = 'MANIFEST_URI',
    ASSET_DURATION = 'ASSET_DURATION',
    NUMBER_OF_CONTENT_PROFILES = 'NUMBER_OF_CONTENT_PROFILES',
    CONTENT_DESCRIPTION = 'CONTENT_DESCRIPTION',
    SERVICE_NAME = 'SERVICE_NAME',
    EVENT_TYPE = 'EVENT_TYPE',
    START_TIME = 'START_TIME',
    END_TIME = 'END_TIME',
    CURRENT_TIMESTAMP = 'TIMESTAMP',
    USER_ACCOUNT_ID = "USER_ACCOUNT_ID",
    STREAM_START_TIME = "STREAM_START_TIME",
    DATA_CONNECTION_TYPE = "DATA_CONNECTION_TYPE",
    CHANNEL_CHANGE_TIME = "CHANNEL_CHANGE_TIME",
    STREAM_SETUP_TIME = "STREAM_SETUP_TIME",
    DS_SEGMENT_PROFILE_BITRATE = "DS_SEGMENT_PROFILE_BITRATE"
}